import { useMutation } from 'react-query';

import workspaceService from '@app/libs/workspaceService';
import {
  postStartInPersonSession,
  PostStartInPersonSessionResponse,
} from '@app/store/transport-layer/document/documents/participants/session/index';

export default function useInPersonSessionStart() {
  return useMutation<
    PostStartInPersonSessionResponse,
    Error,
    { documentId: string; participantId: string }
  >((params) =>
    postStartInPersonSession({ ...params, workspaceId: workspaceService.getWorkspaceId() })
  );
}
